// extracted by mini-css-extract-plugin
export var disabled = "_2x-5";
export var fileName = "_2x-b";
export var filePreview = "_2x-4";
export var hoverFilter = "_2x-6";
export var imageButton = "_2x-3 _2x-6";
export var imageButtonContainer = "_2x-2";
export var input = "_2x-7";
export var removeButton = "_2x-0";
export var removeButtonFile = "_2x-1";
export var spinner = "_2x-9";
export var spinnerContainer = "_2x-8";
export var videoContainer = "_2x-a _2x-6";